<template>
    <div class="additional-features m-b-36 m-b-small-20">
        <Photo class="additional-features-image mb-6 border-0" :source="$image(item.image)" width="88px" height="88px" />
        <div>
            <Heading
                color="primary"
                class="f-w-700 m-b-4"
                tag="h5"
                size="web-sm"
            >
                {{ item.title }}
            </Heading>

            <Texture
                size="lg"
                color="secondary"
                class="font-normal"
            >
                {{ item.description }}
            </Texture>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>
.additional-features {
    &-image {
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
        background-size: 52px 52px !important;
    }
}
</style>
